import {trimValue} from '../../utilities/utilities';

const maskId = '{{ ID }}';
const width = 88;
const halfWidth = trimValue(width / 2);
const stroke = 4;

const settings = {
    template: `<svg class="audio-tooltip__avatar" viewBox="0 0 ${width} ${width}">
            <defs>
                <mask id="audio-tooltip__avatar--${maskId}">
                    <circle cx="${halfWidth}" cy="${halfWidth}" r="${halfWidth}" fill="white"></circle>
                </mask>

                <mask id="audio-tooltip__avatar-stroke--${maskId}">
                    <circle cx="${halfWidth}" cy="${halfWidth}" r="${halfWidth}" fill="white"></circle>
                    <circle cx="${halfWidth}" cy="${halfWidth}" r="${halfWidth - stroke}" fill="black"></circle>
                </mask>
            </defs>
            <g>
                <image href="/themes/custom/${__themeDirectory}/images/audio-tooltip/avatar-circle.png" x="0" y="0" width="${width}" height="${width}" mask="url(#audio-tooltip__avatar--${maskId})"></image>
                <rect x="0" y="0" width="${width}" height="${width}" mask="url(#audio-tooltip__avatar-stroke--${maskId})"></rect>
            </g>
        </svg>`,
};

export default class Avatar {
    constructor() {
        // Insert a unique ID where necessary into our SVG template
        const uniqueMaskId = Math.round(Math.random() * 10000);
        let template = settings.template;
        template = template.replaceAll(maskId, uniqueMaskId);

        // Create our SVG element
        /** @type {Element} */
        this.container = document.createElement('div');
        this.container.innerHTML = template;
        this.container = this.container.firstChild;
    }

    createShowAnimation(
        cssPropertyElement,
        timeline,
        duration,
        delay,
        immediate = false,
    ) {
        if (immediate) {
            // Set final state
            cssPropertyElement.style.setProperty(
                '--avatar-scale',
                1,
            );

            // Stop here
            return;
        }

        const progress = {
            percentComplete: 0,
        };

        // Set initial state
        cssPropertyElement.style.setProperty(
            '--avatar-scale',
            0,
        );

        timeline.to(
            progress,
            duration,
            {
                ease: 'power4.out',
                percentComplete: 1,
                onUpdate: () => {
                    cssPropertyElement.style.setProperty(
                        '--avatar-scale',
                        trimValue(progress.percentComplete),
                    );
                },
            },
            delay,
        );
    }

    createHideAnimation(
        cssPropertyElement,
        timeline,
        duration,
        delay,
        immediate = false,
        ease = null,
    ) {
        if (immediate) {
            // Set final state
            cssPropertyElement.style.setProperty(
                '--avatar-scale',
                0,
            );

            // Stop here
            return;
        }

        const progress = {
            percentComplete: 0,
        };

        // Set initial state
        cssPropertyElement.style.setProperty(
            '--avatar-scale',
            1,
        );

        timeline.from(
            progress,
            duration,
            {
                ease: ease ? ease : 'power1.in',
                percentComplete: 1,
                onUpdate: () => {
                    cssPropertyElement.style.setProperty(
                        '--avatar-scale',
                        trimValue(progress.percentComplete),
                    );
                },
            },
            delay,
        );
    }
}
